<!-- issue#2398 start -->
<!-- Description: Renderer intentionally has no dedicated copy button; copy is handled by the grid's context menu to include both details and peripherals content -->
<!-- issue#2398 end -->
<div
  class="comment-cell"
  [class.expandable]="showToggle"
  (click)="toggleExpand()"
>
  <span *ngIf="showToggle" class="toggle-icon">
    {{ expanded ? 'v' : '>' }}
  </span>
  <span class="comment-text" [ngClass]="{ collapsed: showToggle && !expanded }">
    {{ value }}
  </span>
</div>
<!-- <div *ngIf="expanded" >
  <div *ngIf="peripheralsArray != undefined">
      <div *ngFor="let item of peripheralsArray">
        <ul *ngIf="item != null" class="peripheralDescWrapper">
          <li *ngFor="let item1 of item.peripherals" class="peripheralDesc">
            <strong>{{item1.product.make}}</strong> peripheral added with MAC address <strong>{{item1.id}}</strong> at Location <strong>{{item1.locationName}}</strong>.
          </li>
        </ul>
      </div>
  </div> -->
  <div *ngIf="expanded" >

        <ul *ngIf="peripheralsArray !== null" class="peripheralDescWrapper">
            <li *ngFor="let item of peripheralsArray" class="peripheralDesc">
              <!-- <ng-container *ngIf="!isNotCollapse; else displayDeleted">
                <strong>{{item.product.make}}</strong>
                peripheral added with MAC address
                <strong>{{item.macAddress}}</strong> at Location
                <strong>{{item.locationName}}</strong>.
              </ng-container>
              <ng-template #displayDeleted>
                <strong>{{item.product.make}}</strong> peripheral deleted with MAC address <strong>{{item.macAddress}}</strong> at Location <strong>{{item.locationName}}</strong>.
              </ng-template> -->

              <ng-container *ngIf="isUpdated; else deletedBlock">
                <strong>{{item?.product?.make}}</strong>
                peripheral updated with MAC address
                <strong>{{item?.macAddress}}</strong> at Location
                <strong>{{item?.locationName}}</strong>.
              </ng-container>

              <ng-template #deletedBlock>
                <ng-container *ngIf="isDeleted; else addedBlock">
                  <strong>{{item?.product?.make}}</strong>
                  peripheral deleted with MAC address
                  <strong>{{item?.macAddress}}</strong> at Location
                  <strong>{{item?.locationName}}</strong>.
                </ng-container>
              </ng-template>

              <ng-template #addedBlock>
                <ng-container *ngIf="isNotCollapse">
                  <strong>{{item?.product?.make}}</strong>
                  peripheral added with MAC address
                  <strong>{{item?.macAddress}}</strong> at Location
                  <strong>{{item?.locationName}}</strong>.
                </ng-container>
              </ng-template>

            </li>

        </ul>

</div>

